import {
  ExitToApp as LogoutIcon,
  Menu as MenuIcon,
  Person as PersonIcon,
} from "@mui/icons-material";
import {
  Alert,
  AppBar,
  Avatar,
  Box,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Snackbar,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import NotificationMenu from "./NotificationMenu";

const Header = ({ onMenuClick }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [currentTime, setCurrentTime] = useState(new Date());
  const [anchorEl, setAnchorEl] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  // Atualizar relógio a cada segundo
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleProfileClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString("pt-BR", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const handleLogout = () => {
    logout();
    handleClose();
  };

  const handlePerfilClick = () => {
    navigate("/perfil");
    handleClose();
  };

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{
        bgcolor: "white",
        borderBottom: "1px solid #e0e0e0",
        color: "#333",
      }}
    >
      <Toolbar
        sx={{ justifyContent: "space-between", minHeight: "64px !important" }}
      >
        {/* Menu Button */}
        <IconButton
          edge="start"
          onClick={onMenuClick}
          sx={{
            color: "#333",
            display: { xs: "block", md: "none" },
          }}
        >
          <MenuIcon />
        </IconButton>

        {/* Title/Search area */}
        <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center" }}>
          <Typography
            variant="h6"
            sx={{
              color: "#333",
              fontWeight: 500,
              display: { xs: "none", sm: "block" },
            }}
          >
            Gerenciador de obrigações contábeis
          </Typography>
        </Box>

        {/* Right side items */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {/* Clock */}
          <Box
            sx={{ textAlign: "center", display: { xs: "none", md: "block" } }}
          >
            <Typography variant="h5" sx={{ color: "#333", fontWeight: "bold" }}>
              {formatTime(currentTime)}
            </Typography>
            <Typography variant="caption" sx={{ color: "#666" }}>
              {formatDate(currentTime)}
            </Typography>
          </Box>

          {/* Notifications */}
          <NotificationMenu />

          {/* User Profile */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Box
              sx={{ textAlign: "right", display: { xs: "none", sm: "block" } }}
            >
              <Typography variant="subtitle2" sx={{ color: "#333" }}>
                {user?.nome || "Usuário"}
              </Typography>
            </Box>
            <IconButton onClick={handleProfileClick} sx={{ p: 0 }}>
              <Avatar
                sx={{
                  width: 40,
                  height: 40,
                  bgcolor: "#4a5568",
                }}
              >
                {user?.nome
                  ? user.nome
                      .split(" ")
                      .map((n) => n[0])
                      .join("")
                      .slice(0, 2)
                      .toUpperCase()
                  : "U"}
              </Avatar>
            </IconButton>
          </Box>
        </Box>

        {/* Profile Menu */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <MenuItem onClick={handlePerfilClick}>
            <PersonIcon sx={{ mr: 1 }} />
            Meu perfil
          </MenuItem>
          <Divider />
          <MenuItem onClick={handleLogout}>
            <LogoutIcon sx={{ mr: 1 }} />
            Sair
          </MenuItem>
        </Menu>
      </Toolbar>

      {/* Snackbar para mensagens de sucesso */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          variant="filled"
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </AppBar>
  );
};

export default Header;
